











import { Component, Vue } from "vue-property-decorator";
import { withRank } from "@/req/home";
import listFeature from "./listFeature.vue";
import listContent from "./listContent.vue";

@Component({
  components: { listFeature, listContent },
})
export default class Logout extends Vue {
  public data: any = [];
  public type = 1;
  // 数据加载
  public mounted() {
    this.withRank();
    this.$store.dispatch("withRank/getWithRank");
  }
  public async withRank() {
    this.$store.state.withRank.versions = "";
    this.$store.state.withRank.tag = "";
  }
}
